export const ShipmentRequestSupplierPage = () => {
    return <>ShipmentRequestSupplierPage</>
}